// import React, { useState, useEffect } from 'react';
// import InstituteDashboard from './InstituteDashboard';
//
// const ManageProfExams = () => {
//     const [professionalExams, setProfessionalExams] = useState([]);
//
//     useEffect(() => {
//         fetchProfessionalExams();
//     }, []);
//
//     const fetchProfessionalExams = async () => {
//         try {
//             const response = await fetch('https://api.myskills.lk/professionalExams/all');
//             const data = await response.json();
//             setProfessionalExams(data);
//         } catch (error) {
//             console.error('Error fetching Professional Exams:', error);
//         }
//     };
//
//     const handleDelete = async (examId) => {
//         try {
//             const response = await fetch(`https://api.myskills.lk/professionalExams/delete/${examId}`, {
//                 method: 'POST'
//             });
//             if (response.ok) {
//                 setProfessionalExams(professionalExams.filter(exam => exam.id !== examId));
//                 window.alert('Professional Exam Deleted');
//             } else {
//                 console.error('Failed to delete Professional Exam');
//             }
//         } catch (error) {
//             console.error('Error deleting Professional Exam:', error);
//         }
//     };
//
//     return (
//         <div>
//             <InstituteDashboard />
//             <div className='AllViews-admin-course'>
//                 <div className="search-icon-admin admin-course-search">
//                     <h1>MANAGE PROFESSIONAL EXAMS</h1>
//                     <form>
//                         <input type="text" placeholder='Search Item' />
//                         <input type="submit" value="SEARCH" />
//                     </form>
//                 </div>
//
//                 <div className="scroller-box">
//                     <div className="table-course">
//                         <table>
//                             <thead>
//                                 <tr>
//                                     <th>Exam Name</th>
//                                     <th>Short Name</th>
//                                     <th>Institution</th>
//                                     <th>Start Date</th>
//                                     <th>Duration</th>
//                                     <th>Fee</th>
//                                     <th>Contact No.</th>
//                                     <th>Email</th>
//                                     <th>View</th>
//                                     <th>Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {/*{professionalExams.map((exam) => (*/}
//                                 {/*    <tr key={exam.id}>*/}
//                                 {/*        <td>{exam.examName}</td>*/}
//                                 {/*        <td>{exam.shortName}</td>*/}
//                                 {/*        <td>{exam.university}</td>*/}
//                                 {/*        <td>{new Date(exam.startDate).toLocaleDateString('en-CA')}</td>*/}
//                                 {/*        <td>{exam.duration}</td>*/}
//                                 {/*        <td>{exam.fee}</td>*/}
//                                 {/*        <td>{exam.institutePhone}</td>*/}
//                                 {/*        <td>{exam.instituteEmail}</td>*/}
//                                 {/*        <td>*/}
//                                 {/*            <a href={exam.instituteWebsite} target="_blank" rel="noopener noreferrer">*/}
//                                 {/*                View Website*/}
//                                 {/*            </a>*/}
//                                 {/*        </td>*/}
//                                 {/*        <td id='action-buttons'>*/}
//                                 {/*            /!* <a href="#!" id='edit-details' onClick={() => handleEdit(exam.id)}>EDIT</a> *!/*/}
//                                 {/*            <a href="#!" id='del-details' onClick={() => handleDelete(exam.id)}>DELETE</a>*/}
//                                 {/*        </td>*/}
//                                 {/*    </tr>*/}
//                                 {/*))}*/}
//
//                                 {professionalExams.map((exam) => (
//                                     <tr key={exam.id}>
//                                         <td>{exam.examName}</td>
//                                         <td>{exam.shortName}</td>
//                                         <td>{exam.university}</td>
//                                         <td>
//                                             {
//                                                 // Show start date from the first tableRow, if available
//                                                 exam.tableRows?.[0]?.startDate
//                                                     ? new Date(exam.tableRows[0].startDate).toLocaleDateString('en-CA')
//                                                     : '-'
//                                             }
//                                         </td>
//                                         <td>
//                                             {
//                                                 exam.tableRows?.map(row => row.duration).filter(Boolean).join(', ')
//                                             }
//                                         </td>
//                                         <td>{exam.tableRows?.[0]?.examFee || '-'}</td>
//                                         <td>{exam.institutePhone}</td>
//                                         <td>{exam.instituteEmail}</td>
//                                         <td>
//                                             <a href={exam.instituteWebsite} target="_blank" rel="noopener noreferrer">
//                                                 View Website
//                                             </a>
//                                         </td>
//                                         <td id='action-buttons'>
//                                             <a href="#!" id='del-details' onClick={() => handleDelete(exam.id)}>
//                                                 DELETE
//                                             </a>
//                                         </td>
//                                     </tr>
//                                 ))}
//
//
//
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
//
// export default ManageProfExams;

//
//
// import React, { useState, useEffect } from 'react';
// import InstituteDashboard from './InstituteDashboard';
//
// const ManageProfExams = () => {
//     const [professionalExams, setProfessionalExams] = useState([]);
//     const [editingExamId, setEditingExamId] = useState(null);
//     const [editedExam, setEditedExam] = useState({});
//     const [searchTerm, setSearchTerm] = useState('');
//
//     useEffect(() => {
//         fetchProfessionalExams();
//     }, []);
//
//     const fetchProfessionalExams = async () => {
//         try {
//             const response = await fetch('https://api.myskills.lk/professionalExams/all');
//             const data = await response.json();
//             setProfessionalExams(data);
//         } catch (error) {
//             console.error('Error fetching Professional Exams:', error);
//         }
//     };
//
//     const handleEdit = (exam) => {
//         setEditingExamId(exam.id);
//         setEditedExam({ ...exam });
//     };
//
//     const handleCancel = () => {
//         setEditingExamId(null);
//         setEditedExam({});
//     };
//
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setEditedExam(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };
//
//     const handleSave = async (id) => {
//         try {
//             const response = await fetch(`https://api.myskills.lk/professionalExams/update/${id}`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(editedExam),
//             });
//
//             if (response.ok) {
//                 setProfessionalExams(prev =>
//                     prev.map(exam => (exam.id === id ? editedExam : exam))
//                 );
//                 setEditingExamId(null);
//                 setEditedExam({});
//             } else {
//                 console.error('Failed to update professional exam');
//             }
//         } catch (error) {
//             console.error('Error updating professional exam:', error);
//         }
//     };
//
//     const handleDelete = async (examId) => {
//         try {
//             const response = await fetch(`https://api.myskills.lk/professionalExams/delete/${examId}`, {
//                 method: 'POST'
//             });
//             if (response.ok) {
//                 setProfessionalExams(prev => prev.filter(exam => exam.id !== examId));
//                 window.alert('Professional Exam Deleted');
//             } else {
//                 console.error('Failed to delete Professional Exam');
//             }
//         } catch (error) {
//             console.error('Error deleting Professional Exam:', error);
//         }
//     };
//
//     const filteredExams = professionalExams.filter((exam) =>
//         exam.examName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         exam.shortName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         exam.university?.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//
//     return (
//         <div>
//             <InstituteDashboard />
//             <div className='AllViews-admin-course'>
//                 <div className="search-icon-admin admin-course-search">
//                     <h1>MANAGE PROFESSIONAL EXAMS</h1>
//                     <form onSubmit={(e) => e.preventDefault()}>
//                         <input
//                             type="text"
//                             placeholder='Search by Exam Name, Short Name or University'
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                         />
//                         <input type="submit" value="SEARCH" />
//                     </form>
//                 </div>
//
//                 <div className="scroller-box">
//                     <div className="table-course">
//                         <table>
//                             <thead>
//                             <tr>
//                                 <th>Exam Name</th>
//                                 <th>Short Name</th>
//                                 <th>Institution</th>
//                                 <th>Start Date</th>
//                                 <th>Duration</th>
//                                 <th>Fee</th>
//                                 <th>Contact No.</th>
//                                 <th>Email</th>
//                                 <th>View</th>
//                                 <th>Action</th>
//                             </tr>
//                             </thead>
//                             <tbody>
//                             {filteredExams.map((exam) => (
//                                 <tr key={exam.id}>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="text"
//                                                 name="examName"
//                                                 value={editedExam.examName || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             exam.examName
//                                         )}
//                                     </td>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="text"
//                                                 name="shortName"
//                                                 value={editedExam.shortName || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             exam.shortName
//                                         )}
//                                     </td>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="text"
//                                                 name="university"
//                                                 value={editedExam.university || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             exam.university
//                                         )}
//                                     </td>
//                                     <td>
//                                         {exam.tableRows?.[0]?.startDate
//                                             ? new Date(exam.tableRows[0].startDate).toLocaleDateString('en-CA')
//                                             : '-'}
//                                     </td>
//                                     <td>
//                                         {exam.tableRows?.map(row => row.duration).filter(Boolean).join(', ')}
//                                     </td>
//                                     <td>{exam.tableRows?.[0]?.examFee || '-'}</td>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="text"
//                                                 name="institutePhone"
//                                                 value={editedExam.institutePhone || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             exam.institutePhone
//                                         )}
//                                     </td>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="email"
//                                                 name="instituteEmail"
//                                                 value={editedExam.instituteEmail || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             exam.instituteEmail
//                                         )}
//                                     </td>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="text"
//                                                 name="instituteWebsite"
//                                                 value={editedExam.instituteWebsite || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             <a href={exam.instituteWebsite} target="_blank" rel="noopener noreferrer">
//                                                 View Website
//                                             </a>
//                                         )}
//                                     </td>
//                                     <td id="action-buttons">
//                                         {editingExamId === exam.id ? (
//                                             <>
//                                                 <a href="#!" id="man-details" onClick={() => handleSave(exam.id)}>SAVE</a>
//                                                 <a href="#!" id="del-details" onClick={handleCancel}>CANCEL</a>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <a href="#!" id="man-details" onClick={() => handleEdit(exam)}>EDIT</a>
//                                                 <a href="#!" id="del-details" onClick={() => handleDelete(exam.id)}>DELETE</a>
//                                             </>
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
//
// export default ManageProfExams;
//


//
//
// import React, { useState, useEffect } from 'react';
// import InstituteDashboard from './InstituteDashboard';
//
// const ManageProfExams = () => {
//     const [professionalExams, setProfessionalExams] = useState([]);
//     const [editingExamId, setEditingExamId] = useState(null);
//     const [editedExam, setEditedExam] = useState({});
//     const [searchTerm, setSearchTerm] = useState('');
//
//     useEffect(() => {
//         fetchProfessionalExams();
//     }, []);
//
//     const fetchProfessionalExams = async () => {
//         try {
//             const response = await fetch('https://api.myskills.lk/professionalExams/all');
//             const data = await response.json();
//             setProfessionalExams(data);
//         } catch (error) {
//             console.error('Error fetching Professional Exams:', error);
//         }
//     };
//
//     const handleEdit = (exam) => {
//         setEditingExamId(exam.id);
//         setEditedExam({ ...exam });
//     };
//
//     const handleCancel = () => {
//         setEditingExamId(null);
//         setEditedExam({});
//     };
//
//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setEditedExam(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };
//
//     const handleSave = async (id) => {
//         try {
//             const examToSave = {
//                 ...editedExam,
//                 tableRows: JSON.stringify(editedExam.tableRows || [])
//             };
//
//             const response = await fetch(`https://api.myskills.lk/professionalExams/update/${id}`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(examToSave),
//             });
//
//             if (response.ok) {
//                 setProfessionalExams(prev =>
//                     prev.map(exam => (exam.id === id ? editedExam : exam))
//                 );
//                 setEditingExamId(null);
//                 setEditedExam({});
//             } else {
//                 console.error('Failed to update professional exam');
//             }
//         } catch (error) {
//             console.error('Error updating professional exam:', error);
//         }
//     };
//
//     const handleDelete = async (examId) => {
//         try {
//             const response = await fetch(`https://api.myskills.lk/professionalExams/delete/${examId}`, {
//                 method: 'POST'
//             });
//             if (response.ok) {
//                 setProfessionalExams(prev => prev.filter(exam => exam.id !== examId));
//                 window.alert('Professional Exam Deleted');
//             } else {
//                 console.error('Failed to delete Professional Exam');
//             }
//         } catch (error) {
//             console.error('Error deleting Professional Exam:', error);
//         }
//     };
//
//     const filteredExams = professionalExams.filter((exam) =>
//         exam.examName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         exam.shortName?.toLowerCase().includes(searchTerm.toLowerCase())
//     );
//
//     return (
//         <div>
//             <InstituteDashboard />
//             <div className='AllViews-admin-course'>
//                 <div className="search-icon-admin admin-course-search">
//                     <h1>MANAGE PROFESSIONAL EXAMS</h1>
//                     <form onSubmit={(e) => e.preventDefault()}>
//                         <input
//                             type="text"
//                             placeholder='Search by Exam Name, Short Name or University'
//                             value={searchTerm}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                         />
//                         <input type="submit" value="SEARCH" />
//                     </form>
//                 </div>
//
//                 <div className="scroller-box">
//                     <div className="table-course">
//                         <table>
//                             <thead>
//                             <tr>
//                                 <th>Exam Name</th>
//                                 <th>Short Name</th>
//                                 <th>Institution</th>
//                                 <th>Start Date</th>
//                                 <th>Duration</th>
//                                 <th>Fee</th>
//                                 <th>Contact No.</th>
//                                 <th>Email</th>
//                                 <th>View</th>
//                                 <th>Action</th>
//                             </tr>
//                             </thead>
//                             <tbody>
//                             {filteredExams.map((exam) => (
//                                 <tr key={exam.id}>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="text"
//                                                 name="examName"
//                                                 value={editedExam.examName || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             exam.examName
//                                         )}
//                                     </td>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="text"
//                                                 name="shortName"
//                                                 value={editedExam.shortName || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             exam.shortName
//                                         )}
//                                     </td>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="text"
//                                                 name="university"
//                                                 value={editedExam.university || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             exam.university
//                                         )}
//                                     </td>
//                                     <td>
//                                         {exam.tableRows?.[0]?.startDate
//                                             ? new Date(exam.tableRows[0].startDate).toLocaleDateString('en-CA')
//                                             : '-'}
//                                     </td>
//                                     <td>
//                                         {exam.tableRows?.map(row => row.duration).filter(Boolean).join(', ')}
//                                     </td>
//                                     <td>{exam.tableRows?.[0]?.examFee || '-'}</td>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="text"
//                                                 name="institutePhone"
//                                                 value={editedExam.institutePhone || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             exam.institutePhone
//                                         )}
//                                     </td>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="email"
//                                                 name="instituteEmail"
//                                                 value={editedExam.instituteEmail || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             exam.instituteEmail
//                                         )}
//                                     </td>
//                                     <td>
//                                         {editingExamId === exam.id ? (
//                                             <input
//                                                 type="text"
//                                                 name="instituteWebsite"
//                                                 value={editedExam.instituteWebsite || ''}
//                                                 onChange={handleChange}
//                                             />
//                                         ) : (
//                                             <a href={exam.instituteWebsite} target="_blank" rel="noopener noreferrer">
//                                                 View Website
//                                             </a>
//                                         )}
//                                     </td>
//                                     <td id="action-buttons">
//                                         {editingExamId === exam.id ? (
//                                             <>
//                                                 <a href="#" id="man-details" onClick={() => handleSave(exam.id)}>SAVE</a>
//                                                 <a href="#" id="del-details" onClick={handleCancel}>CANCEL</a>
//                                             </>
//                                         ) : (
//                                             <>
//                                                 <a href="#" id="man-details" onClick={() => handleEdit(exam)}>EDIT</a>
//                                                 <a href="#" id="del-details" onClick={() => handleDelete(exam.id)}>DELETE</a>
//                                             </>
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };
//
// export default ManageProfExams;
//



import React, { useState, useEffect } from 'react';
import InstituteDashboard from './InstituteDashboard';

const ManageProfExams = () => {
    const [professionalExams, setProfessionalExams] = useState([]);
    const [editingExamId, setEditingExamId] = useState(null);
    const [editedExam, setEditedExam] = useState({});
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        fetchProfessionalExams();
    }, []);

    const fetchProfessionalExams = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/professionalExams/all');
            const data = await response.json();
            setProfessionalExams(data);
        } catch (error) {
            console.error('Error fetching Professional Exams:', error);
        }
    };

    const handleEdit = (exam) => {
        let parsedRows = [];
        try {
            parsedRows = typeof exam.tableRows === 'string' ? JSON.parse(exam.tableRows) : exam.tableRows || [];
        } catch (err) {
            console.error('Failed to parse tableRows:', err);
        }
        setEditingExamId(exam.id);
        setEditedExam({ ...exam, tableRows: parsedRows });
    };

    const handleCancel = () => {
        setEditingExamId(null);
        setEditedExam({});
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditedExam(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleTableRowChange = (field, value) => {
        setEditedExam(prev => {
            const updated = [...(prev.tableRows || [])];
            if (!updated[0]) updated[0] = {};
            updated[0][field] = value;
            return { ...prev, tableRows: updated };
        });
    };

    const handleSave = async (id) => {
        try {
            const examToSave = {
                ...editedExam,
                tableRows: JSON.stringify(editedExam.tableRows || [])
            };

            const response = await fetch(`https://api.myskills.lk/professionalExams/update/${id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(examToSave),
            });

            if (response.ok) {
                setProfessionalExams(prev =>
                    prev.map(exam => (exam.id === id ? editedExam : exam))
                );
                setEditingExamId(null);
                setEditedExam({});
            } else {
                console.error('Failed to update professional exam');
            }
        } catch (error) {
            console.error('Error updating professional exam:', error);
        }
    };

    const handleDelete = async (examId) => {
        try {
            const response = await fetch(`https://api.myskills.lk/professionalExams/delete/${examId}`, {
                method: 'POST'
            });
            if (response.ok) {
                setProfessionalExams(prev => prev.filter(exam => exam.id !== examId));
                window.alert('Professional Exam Deleted');
            } else {
                console.error('Failed to delete Professional Exam');
            }
        } catch (error) {
            console.error('Error deleting Professional Exam:', error);
        }
    };

    const filteredExams = professionalExams.filter((exam) =>
        exam.examName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        exam.shortName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div>
            <InstituteDashboard />
            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>MANAGE PROFESSIONAL EXAMS</h1>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <input
                            type="text"
                            placeholder='Search by Exam Name, Short Name or University'
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <input type="submit" value="SEARCH" />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                        <table>
                            <thead>
                            <tr>
                                <th>Exam Name</th>
                                <th>Short Name</th>
                                <th>Institution</th>
                                <th>Start Date</th>
                                <th>Duration</th>
                                <th>Fee</th>
                                <th>Contact No.</th>
                                <th>Email</th>
                                <th>View</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {filteredExams.map((exam) => (
                                <tr key={exam.id}>
                                    <td>
                                        {editingExamId === exam.id ? (
                                            <input
                                                type="text"
                                                name="examName"
                                                value={editedExam.examName || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            exam.examName
                                        )}
                                    </td>
                                    <td>
                                        {editingExamId === exam.id ? (
                                            <input
                                                type="text"
                                                name="shortName"
                                                value={editedExam.shortName || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            exam.shortName
                                        )}
                                    </td>
                                    <td>
                                        {editingExamId === exam.id ? (
                                            <input
                                                type="text"
                                                name="university"
                                                value={editedExam.university || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            exam.university
                                        )}
                                    </td>
                                    <td>
                                        {editingExamId === exam.id ? (
                                            <input
                                                type="date"
                                                value={editedExam.tableRows?.[0]?.startDate?.split('T')[0] || ''}
                                                onChange={(e) => handleTableRowChange('startDate', e.target.value)}
                                            />
                                        ) : (
                                            exam.tableRows?.[0]?.startDate
                                                ? new Date(exam.tableRows[0].startDate).toLocaleDateString('en-CA')
                                                : '-'
                                        )}
                                    </td>
                                    <td>
                                        {editingExamId === exam.id ? (
                                            <input
                                                type="text"
                                                value={editedExam.tableRows?.[0]?.duration || ''}
                                                onChange={(e) => handleTableRowChange('duration', e.target.value)}
                                            />
                                        ) : (
                                            exam.tableRows?.map(row => row.duration).filter(Boolean).join(', ')
                                        )}
                                    </td>
                                    <td>
                                        {editingExamId === exam.id ? (
                                            <input
                                                type="number"
                                                value={editedExam.tableRows?.[0]?.examFee || ''}
                                                onChange={(e) => handleTableRowChange('examFee', e.target.value)}
                                            />
                                        ) : (
                                            exam.tableRows?.[0]?.examFee || '-'
                                        )}
                                    </td>
                                    <td>
                                        {editingExamId === exam.id ? (
                                            <input
                                                type="text"
                                                name="institutePhone"
                                                value={editedExam.institutePhone || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            exam.institutePhone
                                        )}
                                    </td>
                                    <td>
                                        {editingExamId === exam.id ? (
                                            <input
                                                type="email"
                                                name="instituteEmail"
                                                value={editedExam.instituteEmail || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            exam.instituteEmail
                                        )}
                                    </td>
                                    <td>
                                        {editingExamId === exam.id ? (
                                            <input
                                                type="text"
                                                name="instituteWebsite"
                                                value={editedExam.instituteWebsite || ''}
                                                onChange={handleChange}
                                            />
                                        ) : (
                                            <a href={exam.instituteWebsite} target="_blank" rel="noopener noreferrer">
                                                View Website
                                            </a>
                                        )}
                                    </td>
                                    <td id="action-buttons">
                                        {editingExamId === exam.id ? (
                                            <>
                                                <a href="#" id="man-details" onClick={() => handleSave(exam.id)}>SAVE</a>
                                                <a href="#" id="del-details" onClick={handleCancel}>CANCEL</a>
                                            </>
                                        ) : (
                                            <>
                                                <a href="#" id="man-details" onClick={() => handleEdit(exam)}>EDIT</a>
                                                <a href="#" id="del-details" onClick={() => handleDelete(exam.id)}>DELETE</a>
                                            </>
                                        )}
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageProfExams;
